import * as React from 'react';
import * as Autosuggest from 'react-autosuggest';
import Bible from 'src/bible/Bible';
import BibleVerse from 'src/bible/BibleVerse';
import './VerseSearch.css';

interface Props {
    bible: Bible;
    onSelect: (verse: BibleVerse) => void;
}

interface State {
    query: string;
    suggestions: BibleVerse[];
}

export default class VerseSearch extends React.Component<Props, State> {

    private maxSuggestions = 50;

    constructor(props: Props) {
        super(props);
        this.state = {
            query: '',
            suggestions: []
        };
        this.onChange = this.onChange.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    }

    public render(): React.ReactNode {
        const inputProps = {
            value: this.state.query,
            placeholder: 'Search for verses',
            onChange: this.onChange
        };
        return (
            <div className="VerseSearch">
                <Autosuggest<BibleVerse>
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    highlightFirstSuggestion={true}
                    focusInputOnSuggestionClick={false} />
            </div>
        );
    }

    private onChange(event: React.FormEvent<any>, params: Autosuggest.ChangeEvent): void {
        this.setState({ query: params.newValue });
    }

    private onSuggestionsFetchRequested(request: Autosuggest.SuggestionsFetchRequestedParams): void {
        const words = request.value.split(' ');
        const regexes = words.filter(word => word.length > 0)
                .map(word => new RegExp('(?:^|\\s)' + word, 'i')); // TODO: Escape string in regex.
        let suggestionsFound = 0;

        const suggestions = this.props.bible.getVerses().filter((verse) => {
            if (suggestionsFound >= this.maxSuggestions) {
                return false;
            }
            const isMatch = regexes.reduce<boolean>((sum, value) => sum && value.test(verse.getName()), true) ||
                    regexes.reduce((sum, value) => sum && value.test(verse.getShortName()), true);
            if (isMatch) {
                suggestionsFound++;
            }
            return isMatch;
        });
        this.setState({ suggestions });
    }

    private onSuggestionsClearRequested(): void {
        this.setState({ suggestions: [] });
    }

    private onSuggestionSelected(event: React.FormEvent<any>, data: Autosuggest.SuggestionSelectedEventData<BibleVerse>): void {
        this.props.onSelect(data.suggestion);
        this.setState({ query: '' });
    }

    private getSuggestionValue(suggestion: BibleVerse): string {
        return suggestion.getName();
    }

    private renderSuggestion(suggestion: BibleVerse, params: Autosuggest.RenderSuggestionParams): React.ReactNode {
        return suggestion.getName();
    }
}
